import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    params: {
	    orderStatus: '', // 订单状态
	    orderCodesStr: '', // 订单类型
	    memberMobileNumbersStr: '', // 会员手机号
	    shipmentNumber: '', // 订单物流编号
	    skuCodeList: '', // SKU编号
	    consigneeName: '', // 收货人姓名
	    consigneeMobileNumber: '', // 收货人手机号
	    memberCode: '', // 客户编号
	    deliveryMethods: [], // 配送方式
	    orderTypes: [], // 订单类型
	    paymentMethods: [], // 付款方式
	    paymentStatus: '', // 付款状态
	    sourceList: [], // 来源类型
	    orderDate: [], // 下单时间
	    paidDate: [], // 支付时间
	    // createdDate: '', // 下单开始时间
	    // endDate: '', // 下单结束时间
	    // paidStartDate: '', // 付款开始时间
	    // paidEndDate: '', // 付款结束时间
	    excludeOrderTypeList: [16, 18]
    },
    page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
    },
    orderTypeList: [], // 订单类型
    payTypeList: [], // 支付方式类型
    deliveryWayList: [], // 配送方式
    sourceTypeList: [], // 来源类型
    orderList: [] // 订单列表
}

const reducers = createActions({
    setParams: (state, action) => {
        const { params, ...other } = state
        return { ...other, params: { ...params, ...action.payload } }
    },
    getSourceTypeListAction: {
        success: (state, action) => ({
	        ...state,
	        sourceTypeList: Object.entries(action.payload)
		        .sort((a, b) => a[0] - b[0])
		        .map(([k, v]) => ({ label: `${k}-${v}`, value: k }))
        })
    },
    getDeliveryWayAction: {
        success: (state, action) => ({ ...state, deliveryWayList: action.payload })
    },
    getOrderDictInfoByTypeAction: {
        success: (state, action) => ({ ...state, orderTypeList: action.payload })
    },
    getPayDictInfoByTypeAction: {
        success: (state, action) => ({ ...state, payTypeList: action.payload})
    },
    getOrderListAction: {
        pending: (state, action) => {
            const { meta: { arg: { data } } } = action
	        const { pageNum, pageSize, createdDate, endDate, paidStartDate, paidEndDate, ...otherParams } = data
	        const orderDate = createdDate ?[createdDate, endDate] : []
	        const paidDate = paidStartDate ? [paidStartDate, paidEndDate] : []
	        
	        return {
                ...state,
		        params: { ...otherParams, orderDate, paidDate },
		        page: { ...state.page, pageNum, pageSize }
            }
        },
        success: (state, action) => {
	        const { total, list } = action.payload
	        const orderList = list.map(li => ({ ...li, key: li.orderCode }))
			
            return {
                ...state,
	            page: { ...state.page, total },
	            orderList
            }
        }
    }
}, actions)

const orderSlice = createSlice({
    name: 'order',
    initialState,
    ...reducers
})

export const getParams = state => state.order.params

export const getPages = state => state.order.page

export const getOrderTypeList = state => state.order.orderTypeList
export const getPayTypeList = state => state.order.payTypeList
export const getDeliveryWayList = state => state.order.deliveryWayList
export const getSourceTypeList = state => state.order.sourceTypeList

export const getOrderList = state => state.order.orderList

export const { setParams } = orderSlice.actions

export default orderSlice
